'use strict';
import classNames from 'classnames';
import * as T from 'prop-types';
import React from 'react';


export function ModalContentView(props) {
  return (
    <div
      className={classNames("ModalContent", props.className)}
      style={props.style}
      ref={props.setDivRef}
    >
      {props.children}
    </div>
  );
}

ModalContentView.propTypes = {
  className: T.string,
  hasHeader: T.bool,
  hasFooter: T.bool,
};

// TODO: use this for class and keyboard offset calc
ModalContentView.defaultProps = {
  hasHeader: true,
  hasFooter: true,
};



// WEBPACK FOOTER //
// ./src/js/components/modals/ModalContent/ModalContentView.js